import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { api, fmtCLP } from "../lib/api";
import { Package, ChevronDown, ChevronUp, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function MisPedidos() {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState({});

  useEffect(() => {
    if (!authLoading && !user) {
      navigate("/");
      return;
    }
    if (user) {
      api.get("/auth/orders")
        .then((r) => setOrders(r.data))
        .catch(() => toast.error("Error al cargar pedidos"))
        .finally(() => setLoading(false));
    }
  }, [user, authLoading]);

  if (authLoading || loading) {
    return <div className="min-h-[60vh] flex items-center justify-center"><Loader2 className="animate-spin" size={28} /></div>;
  }

  return (
    <section className="py-12 md:py-16" data-testid="mis-pedidos-page">
      <div className="max-w-4xl mx-auto px-5 md:px-8">
        <div className="text-xs uppercase tracking-[0.25em] font-bold text-[#0EA5E9]">Mi cuenta</div>
        <h1 className="font-heading font-black text-4xl md:text-5xl mt-2">Mis pedidos</h1>
        <p className="text-slate-600 mt-3">Hola {user?.nombre}, aquí están tus compras anteriores.</p>

        <div className="mt-8 space-y-3">
          {orders.length === 0 && (
            <div className="bg-white border border-slate-200 rounded-2xl p-12 text-center">
              <Package size={36} className="mx-auto text-slate-300 mb-3" />
              <div className="text-slate-500">Aún no tienes pedidos. ¡Empieza personalizando tu funda!</div>
            </div>
          )}
          {orders.map((o) => {
            const isOpen = expanded[o.id];
            return (
              <div key={o.id} className="bg-white border border-slate-200 rounded-2xl overflow-hidden" data-testid={`my-order-${o.id}`}>
                <button onClick={() => setExpanded((p) => ({ ...p, [o.id]: !p[o.id] }))} className="w-full px-5 py-4 flex items-center justify-between hover:bg-slate-50">
                  <div className="text-left">
                    <div className="font-heading font-black">{o.order_number}</div>
                    <div className="text-xs text-slate-500">{new Date(o.created_at).toLocaleString("es-CL")} · {o.items.length} productos</div>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-slate-100">{o.status}</span>
                    <span className="font-heading font-black text-lg">{fmtCLP(o.total)}</span>
                    {isOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                  </div>
                </button>
                {isOpen && (
                  <div className="px-5 py-4 border-t bg-slate-50 space-y-2">
                    {o.items.map((it, i) => (
                      <div key={i} className="flex gap-3 items-center bg-white rounded-xl p-2.5 border border-slate-100">
                        <div className="w-12 h-12 rounded-lg bg-slate-100 overflow-hidden flex-shrink-0">
                          {it.image && <img src={it.image} alt="" className="w-full h-full object-cover" />}
                        </div>
                        <div className="flex-1 text-sm">
                          <div className="font-bold">{it.name}</div>
                          <div className="text-xs text-slate-500">x{it.quantity} · {fmtCLP(it.price * it.quantity)}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
